import { Box, Text } from '@factorialco/deprecated-design-system'
import { MissingAgreementDataQueryVariables } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ReturnedData } from '../../../hooks/useMissingAgreementData'
import { MissingGrossSalariesButton } from '../ButtonWithModal'
import { CustomValues } from '../types'

interface Props {
  data: ReturnedData
  variables: MissingAgreementDataQueryVariables
  fromComponent: string
  customValues?: CustomValues
}

export const MissingGrossSalariesBanner = ({
  data,
  variables,
  customValues,
  fromComponent,
}: Props) => {
  return (
    <Box
      gap="s8"
      width="full"
      paddingY="s12"
      paddingX="s24"
      flexDirection="row"
      background="champagne200"
      justifyContent="spaceBetween"
      borderRadius={{ all: 'abs008' }}
    >
      <Box paddingRight="s32">
        <Text.Normal weight="semibold">
          {i18n.t('finance.financial_workspace.missing_data.title')}
        </Text.Normal>
        <Text.Normal>{i18n.t('finance.financial_workspace.missing_data.body')}</Text.Normal>
      </Box>
      <Box alignSelf="center">
        <MissingGrossSalariesButton
          data={data}
          buttonType="upgrade"
          variables={variables}
          customValues={customValues}
          fromComponent={fromComponent}
        />
      </Box>
    </Box>
  )
}
